import { countElementsByRoom } from "../rooms";
import type { BuildRoomExportSections } from "./types";

export const buildRoomExportSections: BuildRoomExportSections = ({
  rooms,
  selectedLabels,
  byGroupId,
  t,
}) => {
  const roomElementCounts = countElementsByRoom({
    rooms,
    groupIds: selectedLabels,
    byGroupId,
  });
  return roomElementCounts.map(({ room, groups, total }) => ({
    items: groups.map((group) => ({
      label: group.label,
      value: String(group.quantity),
      rgb: group.rgb,
    })),
    summary: {
      left: room.name,
      right: t("smartSurveyor.exportExcel.legendElementsCount", {
        count: total,
      }),
    },
  }));
};
